/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Billing_View_InvoiceInputs */



/**
* | output |
* | --- |
* | "View invoice" |
*
* @param {Dashboard_Billing_View_InvoiceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_billing_view_invoice = /** @type {((inputs?: Dashboard_Billing_View_InvoiceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Billing_View_InvoiceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Rechnung ansehen")
	return /** @type {LocalizedString} */ ("View invoice")
});